import { render } from "./CompanyReport.vue?vue&type=template&id=f7bc2718&scoped=true&ts=true"
import script from "./CompanyReport.vue?vue&type=script&lang=ts"
export * from "./CompanyReport.vue?vue&type=script&lang=ts"

import "./CompanyReport.vue?vue&type=style&index=0&id=f7bc2718&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7bc2718"]])

export default __exports__